function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

export function formatDate(d) {
    let date = new Date(d)
    return (
        [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
        ].join('-') +
        ' ' +
        [
            padTo2Digits(date.getHours()),
            padTo2Digits(date.getMinutes()),
            //padTo2Digits(date.getSeconds()),
        ].join(':')
    );
}

export function simpleFormatDate(d)
{
    return d?.replace("T"," ")?.substring(0,16)
}
